import styled from "styled-components";

export const TogasContainer = styled.header`
    height: 100vh;
    background-image: url("/img/Togas-pc.jpg");
    background-size: cover;
    background-position: center right;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    padding: 0 8%;
    align-items: center;
    justify-content: center;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1;
    }

    p {
        font-size: 50px;
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;

        color: transparent;
        -webkit-text-stroke: 1px #fff;

        letter-spacing: 4px;
        z-index: 2;
    }

    @media (max-width: 1024px) {
        background-position: center;
    }

    @media (max-width: 768px) {
        height: 90vh;
        background-position: center top;
        background-image: url("/img/Togas-movil.jpg");
        padding: 0 5%;
    }
`;

export const ButtonContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 20px;
    background: #b5b09b;
    padding: 50px 20px 20px 20px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        justify-items: center;
    }
`;

export const TogaBase = styled.button`
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 15px;
    cursor: pointer;
    transition: all 0.3s ease;

    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    font-size: 1.1rem;;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1.5px;

    padding: 20px;

    &:hover {
        transform: translateY(-5px) scale(1.02);
        box-shadow: 0 12px 25px rgba(0,0,0,0.3);
    }

    &:active {
        transform: scale(0.98);
        box-shadow: none;
    }

    @media (max-width: 768px) {
        max-width: 250px;
    }
`;

export const TogasDoradas = styled(TogaBase)`
    background: #C9A227;
    color: #000000;
    border: 2px solid #000000;

    &:hover {
        background: #365DD8;
        color: #111;
        border: 2px solid #111;
    }
`;

export const TogasTintas = styled(TogaBase)`
    background: #620808;
    color: #fff;
    border: 2px solid #fff;

    &:hover {
        background: #3AAFA9;
        color: #111;
        border: 2px solid #111;
    }
`;

export const TogasAzules = styled(TogaBase)`
    background: #004da5;
    color: #fff;
    border: 2px solid #fff;

    &:hover {
        background: #f77f00;
        color: #111;
        border: 2px solid #111;
    }
`;